/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Filters_Contrast_LabelInputs */



/**
* | output |
* | --- |
* | "Contrast" |
*
* @param {Video_Filters_Contrast_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_filters_contrast_label = /** @type {((inputs?: Video_Filters_Contrast_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Filters_Contrast_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Contraste")
	if (locale === "de") return /** @type {LocalizedString} */ ("Kontrast")
	if (locale === "it") return /** @type {LocalizedString} */ ("Contrasto")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Контраст")
	if (locale === "es") return /** @type {LocalizedString} */ ("Contraste")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("对比")
	if (locale === "ja") return /** @type {LocalizedString} */ ("対比")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अंतर")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Contraste")
	return /** @type {LocalizedString} */ ("Contrast")
});